<footer
    [ngStyle]="{
        'background-image':
            'url(' + ('FOOTER_BACKGROUND-IMAGE_URL' | translate) + ')'
    }"
    class="footer mt-auto text-bg-primary"
>
    <div class="footer-content py-4 container">
        <div class="row">
            <div class="col-12 col-lg-9">
                <div class="row g-0 mb-4">
                    <div class="footer-socials col-6">
                        <div
                            [innerHtml]="
                                'FOOTER_SOCIAL-ACCOUNT_TITLE_TEXT' | translate
                            "
                            class="socials-title mb-1"
                        ></div>
                        <nav class="nav socials-nav">
                            @for(socialItem of socialData$ | async | keyvalue :
                            originalOrder; track socialItem.value['link-url']) {
                            <a
                                [brandHref]="socialItem.value['link-url']"
                                class="nav-link ps-0 pe-1"
                                target="_blank"
                            >
                                <img
                                    [alt]="socialItem.value['icon-alt-text']"
                                    [src]="socialItem.value['social-icon']"
                                />
                            </a>
                            }
                        </nav>
                    </div>
                </div>
                <div class="row">
                    @for(group of navigationData$ | async; track group.category)
                    {
                    <div
                        class="footer-navigation col-12 col-sm-6 col-md-4 mb-4 mb-lg-0"
                    >
                        <div
                            [innerHTML]="
                                'FOOTER_VISION_' +
                                    group.category +
                                    '_CATEGORY_TEXT'
                                    | keyify
                                    | translate
                            "
                            class="navigation-title"
                        ></div>
                        <ul class="nav flex-column">
                            @for(item of group.items; track item['link-url']) {
                            <li class="nav-item">
                                <a
                                    [brandHref]="item['link-url']"
                                    [innerHTML]="
                                        item['title-translated'] ||
                                        item['title']
                                    "
                                    class="nav-link ps-0"
                                ></a>
                            </li>
                            }
                        </ul>
                    </div>
                    }
                </div>
            </div>
            <div class="col-12 col-lg-3 mt-4 mt-lg-0">
                <div class="row">
                    <div class="col-12">
                        <img
                            [src]="'FOOTER_VISION-LOGO_IMAGE_URL' | translate"
                            [alt]="
                                'FOOTER_VISION-LOGO_IMAGE_ALT_TEXT' | translate
                            "
                            class="img-fluid mb-2"
                        />
                    </div>
                    @let globalAddress = ('FOOTER_VISION-ADDRESS-GLOBAL_TEXT' | translate); 
                    @let globalPhone = ('FOOTER_VISION-PHONE-NUMBER-GLOBAL_TEXT' | translate);
                    @if (globalAddress && globalPhone) {
                    <div class="col-12 col-md-6 col-lg-12 mb-2">
                        <address class="address mb-0">
                            <div
                                [innerHtml]="globalAddress"
                                class="small mb-0"
                            ></div>
                        </address>
                        <a
                            [href]="
                                'FOOTER_VISION-PHONE-NUMBER-GLOBAL_LINK'
                                    | translate
                            "
                            [innerHtml]="globalPhone"
                            class="btn-link fw-bold p-0"
                        ></a>
                    </div>
                    } @if('FOOTER_VISION_ADDRESS-REGION_TEXT' | translate; as address) {
                    <div class="col-12 col-md-6 col-lg-12">
                        <address class="address mb-0">
                            <div [innerHtml]="address" class="small mb-0"></div>
                        </address>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="footer-legal-bar bg-gray-100">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-9 col-xl-10">
                    <nav class="nav my-1">
                        @for(legalItem of legalData$ | async | keyvalue :
                        originalOrder; track legalItem.value['link-url']) {
                        <a
                            [brandHref]="legalItem.value['link-url']"
                            [innerHTML]="
                                legalItem.value['title-translated'] ||
                                legalItem.value['title']
                            "
                            class="nav-link py-0"
                        ></a>
                        }
                        <a
                            [innerHtml]="
                                'GLOBAL_RENEW-COOKIE-CONSENT_TEXT' | translate
                            "
                            href="javascript: Cookiebot?.renew()"
                            class="nav-link py-0"
                        ></a>
                    </nav>
                </div>
                <div class="col-12 col-md-3 col-xl-2">
                    <div
                        class="footer--copyright d-flex justify-content-md-end"
                    >
                        <ul class="list-inline list-unstyled my-md-1">
                            <li [innerHtml]="copyRight" class="small"></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
